import Vue from 'vue'
import router from './router';
import vuetify from './plugins/vuetify';
import App from './App.vue';

// plugin para traducir la app a varios idiomas
import i18n from '@/plugins/i18n';

// plugin validacion de formularios
import Vuelidate from "vuelidate"
Vue.use(Vuelidate)

// plugin bootstrap
import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
Vue.use(BootstrapVue)

// selector fecha
import Datepicker from 'vuejs-datepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
Vue.component('datepicker', Datepicker)

// selector hora
import VueTimepicker from 'vue2-timepicker'
Vue.component('vue-timepicker', VueTimepicker)

// manejo de fechas
import moment from 'moment';
Object.defineProperty(Vue.prototype, '$moment', { value: moment });

/// impresion de la reserva
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

// aviso cookies
import cookieconsent from 'vue-cookieconsent-component';
Vue.component('cookie-consent', cookieconsent)
/*// creacion cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)*/


// plugin para utilizar la fuente awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { faWalking } from '@fortawesome/free-solid-svg-icons'
import { faHandPointRight } from '@fortawesome/free-solid-svg-icons'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { faMap } from '@fortawesome/free-solid-svg-icons'
import { faDirections } from '@fortawesome/free-solid-svg-icons'
import { faCommentAlt } from '@fortawesome/free-solid-svg-icons'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons'
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons'
import { faSearchLocation } from '@fortawesome/free-solid-svg-icons'

// solo cargo los iconos concretos de font-awesome
library.add(faCircle)
library.add(faEnvelope)
library.add(faMapMarkerAlt)
library.add(faClock)
library.add(faLock)
library.add(faWalking)
library.add(faHandPointRight)
library.add(faCalendar)
library.add(faMap)
library.add(faDirections)
library.add(faCommentAlt)
library.add(faCalendarCheck)
library.add(faUndoAlt)
library.add(faSearchLocation)

Vue.component('font-awesome-icon', FontAwesomeIcon)


    // Limpieza de los datos de localStorage
/*    window.localStorage.setItem("importeReserva", "");
    window.localStorage.setItem("importeReservaNumero", 0);
    window.localStorage.setItem("fechaEntrada", null);
    window.localStorage.setItem("fechaSalida", null);
    window.localStorage.setItem("horaSalida", "00:00");
    window.localStorage.setItem("horaEntrada", "00:00");
    window.localStorage.setItem("matricula", "");
    window.localStorage.setItem("modelo", "");
    window.localStorage.setItem("color", "");
    window.localStorage.setItem("crucero", "");

    window.localStorage.setItem("nombre", "");
    window.localStorage.setItem("mail", "");
    window.localStorage.setItem("telefono", "");
    window.localStorage.setItem("cif", "");      

    window.localStorage.setItem("direccion", "");
    window.localStorage.setItem("localidad", "");
    window.localStorage.setItem("cp", "");
    window.localStorage.setItem("nombreFac", "");      
    window.localStorage.setItem("pais", "");      
    window.localStorage.setItem("aceptacionTerminos", false);    */  



new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
